import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcMoreArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 9,
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.1406 1.42922L5.99784 7.21484L0.855063 1.42922",
		stroke: "#A5A5A5",
		strokeWidth: 1.6875,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcMoreArrow;
